import { uniqWith } from 'lodash';
import { Moment } from 'moment';
import { SimpleSearchFilter } from 'api/dashboard/widget';
import { DEFAULT_DATE_FORMAT } from 'api/models';
import {
  ApiTimesheetAdhocEntry,
  ApiTimesheetEntry,
  TimesheetEntryType,
} from 'api/timesheets';
import { Option } from 'components/atoms/select/types';
import { QueryCombinerType } from 'components/organisms/tasks/combiner';
import { SourceType } from 'components/organisms/tasks/fields';
import { Operation } from 'utils/simple-search-filter/operations';
import { AdhocTask } from './use-add-adhoc-actions';

export const apiTimeEntriesToAdhocTask = (
  entries: ApiTimesheetEntry[],
  defaultProjectOption: Option,
): AdhocTask[] => {
  const adhocTimeEntries = entries.filter(
    ({ type }) => type === TimesheetEntryType.AdhocEntry,
  ) as ApiTimesheetAdhocEntry[];

  return uniqWith(
    adhocTimeEntries,
    (a, b) =>
      a.activityName === b.activityName && a.project?.id === b.project?.id,
  ).map(
    ({ activityName, project, category, billable }): AdhocTask => ({
      project: project
        ? {
            value: project.id,
            label: project.name,
          }
        : defaultProjectOption,
      activityName,
      billable,
      category: category?.categoryId
        ? {
            value: category.categoryId,
            label: category.categoryName,
          }
        : undefined,
    }),
  );
};

export const getSearchFilterForDateAndUser = (
  date: Moment,
  userId: number,
): SimpleSearchFilter => ({
  match: QueryCombinerType.All,
  nativeFields: [
    {
      name: 'entryDate',
      operation: Operation.GreaterThan,
      value: date.subtract(1, 'day').format(DEFAULT_DATE_FORMAT),
      sourceType: SourceType.Timesheet,
    },
    {
      name: 'entryDate',
      operation: Operation.LessThan,
      value: date.add(7, 'days').format(DEFAULT_DATE_FORMAT),
      sourceType: SourceType.Timesheet,
    },
    {
      name: 'userId',
      operation: Operation.Value,
      value: userId.toString(),
      sourceType: SourceType.Timesheet,
    },
  ],
});
